import { FC, useEffect, useState } from 'react';
import { ISerialAndSKU, IlogisticServiceDetailsToolsData } from '../../../../../../../types/services';
import { ExternalIcon } from 'assets/images/bussines';
import NudosProductPills from '../../../../../../../components/NudosComponents/NudosProductPills/NudosProductPills';
import { NudosButton, NudosTextInput } from '../../../../../../../components/NudosComponents';
import BordOneToneIcon from '../../../../../../../components/NudosComponents/BordOneToneIcon/BordOneToneIcon';
import { metabaseUrl } from '../../../../../../../constants/constants';

import './EditToolsDataModal.scss';

interface IEditToolsDataModalContainer {
  toolData: IlogisticServiceDetailsToolsData;
  updateSerialAndSKU: (
    serialAndSKU?: ISerialAndSKU,
    loaderHandler?: React.Dispatch<React.SetStateAction<boolean>>
  ) => void;
}

const EditToolsDataModalContainer: FC<IEditToolsDataModalContainer> = ({
  toolData,
  updateSerialAndSKU
}: IEditToolsDataModalContainer) => {
  const [serialAndSKU, setSerialAndSKU] = useState<ISerialAndSKU>();
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(false);

  const initialData = () => {
    if (toolData) {
      const defaultData = {
        serial: toolData?.serial?.trim() || '',
        sku: toolData?.sku || ''
      };
      setSerialAndSKU({ ...defaultData });
    }
  };

  const updateToolData = () => updateSerialAndSKU(serialAndSKU, setIsLoading);

  useEffect(() => {
    initialData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toolData]);

  return (
    <div id="editToolsDataModal">
      <div className="boxEditToolsDataModal">
        <div className="editTitle">Agrega o modifica el serial y SKU de la herramienta</div>
        <div className="pillsContainer">
          <div className="editName">{toolData.name}</div>
          {toolData?.pills && (
            <div className="boxPills">
              <NudosProductPills
                xPadding="2px"
                yPadding="4px"
                customLineHeigth="10px"
                customHeight={16}
                pills={toolData?.pills}
              />
            </div>
          )}
          <div className="externalIcon">
            <ExternalIcon fill="#999999" />
          </div>
        </div>
        <div className="inputsEditTools">
          <NudosTextInput
            isFilled={!!serialAndSKU?.serial}
            customClassName="mr-8"
            inputHeight={40}
            placeholder="Serial"
            label="Serial"
            componentSize="small-196"
            defaultValue={serialAndSKU?.serial || ''}
            handleChange={e => {
              setIsEdit(true);
              setSerialAndSKU({ ...serialAndSKU, serial: e?.trim() });
            }}
          />
          <NudosTextInput
            isFilled={!!serialAndSKU?.sku}
            placeholder="SKU"
            label="SKU"
            componentSize="small-196"
            defaultValue={serialAndSKU?.sku || ''}
            handleChange={e => {
              setIsEdit(true);
              setSerialAndSKU({ ...serialAndSKU, sku: e });
            }}
          />
        </div>
        <div className="alertSearchSku">
          <div className="alertSearchSkuContianer">
            <div className="alerIcon">
              <BordOneToneIcon variant="info" customWidth="16px" />
            </div>
            <div className="alertText">
              <div className="titleAlert">Encuentra SKUs más rápido</div>
              <div className="subtitleAlert">
                Usa Metabase para buscar SKUs por modelo, pills y otros filtros de forma más rápida
              </div>
              <a className="linkContainer" href={metabaseUrl} target="_blank" rel="noopener noreferrer">
                Buscar SKUs
              </a>
            </div>
          </div>
        </div>
        <div className="containerSaveButton">
          <NudosButton
            isButtonDisabled={isLoading || !isEdit}
            isButtonLoading={isLoading}
            buttonText="Guardar"
            customHeight="38px"
            customWidth="400px"
            handleClick={updateToolData}
          />
        </div>
      </div>
    </div>
  );
};

export default EditToolsDataModalContainer;
